'use strict';

import React, { useState, useEffect, useCallback, Fragment } from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router';
import moment from 'moment';
import Notification from 'components/Notification';
import {
  createCampaignTarget,
  deleteCampaignTarget,
  getCampaignTarget,
  getFcmList,
  syncCampaignTarget
} from 'utils/network/ServiceHelper';
import { Transition, Listbox } from '@headlessui/react';
import { useLocation } from 'react-router';
import Autocomplete from 'components/Autocomplete';
import {
  ANDROID_LOWERCASE,
  PAGINATION,
  STATUS_UNAUTHORIZED,
  STATUS_SUCCESS
} from 'utils/constants';

const DEVICE_TYPE = ['android', 'ios'];

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function CampaignTarget() {
  const navigate = useNavigate();
  const query = useQuery();

  const columns = [
    {
      name: 'Customer ID',
      sortable: true,
      selector: 'customer_id',
      cell: function render(row) {
        return <>{row.customer_id}</>;
      }
    },
    {
      name: 'Name',
      sortable: true,
      selector: 'name',
      cell: function render(row) {
        return <>{row.name}</>;
      }
    },
    {
      name: 'Email',
      sortable: true,
      selector: 'email',
      cell: function render(row) {
        return <>{row.email}</>;
      }
    },
    {
      name: 'Device Type',
      cell: function render(row) {
        return (
          <>
            {row.device_type === ANDROID_LOWERCASE ? (
              <svg
                key={row.id}
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 mr-3"
                x="0"
                y="0"
                fill="#3CDB85"
                enableBackground="new 0 0 553.048 553.048"
                version="1.1"
                viewBox="0 0 553.048 553.048"
                xmlSpace="preserve"
              >
                <path d="M76.774 179.141c-9.529 0-17.614 3.323-24.26 9.969-6.646 6.646-9.97 14.621-9.97 23.929v142.914c0 9.541 3.323 17.619 9.97 24.266 6.646 6.646 14.731 9.97 24.26 9.97 9.522 0 17.558-3.323 24.101-9.97 6.53-6.646 9.804-14.725 9.804-24.266V213.039c0-9.309-3.323-17.283-9.97-23.929-6.647-6.646-14.627-9.969-23.935-9.969zM351.972 50.847L375.57 7.315c1.549-2.882.998-5.092-1.658-6.646-2.883-1.34-5.098-.661-6.646 1.989l-23.928 43.88c-21.055-9.309-43.324-13.972-66.807-13.972-23.488 0-45.759 4.664-66.806 13.972l-23.929-43.88c-1.555-2.65-3.77-3.323-6.646-1.989-2.662 1.561-3.213 3.764-1.658 6.646l23.599 43.532c-23.929 12.203-42.987 29.198-57.167 51.022-14.18 21.836-21.273 45.698-21.273 71.628h307.426c0-25.924-7.094-49.787-21.273-71.628-14.181-21.824-33.129-38.819-56.832-51.022zm-136.433 63.318c-2.552 2.558-5.6 3.831-9.143 3.831-3.55 0-6.536-1.273-8.972-3.831-2.436-2.546-3.654-5.582-3.654-9.137 0-3.543 1.218-6.585 3.654-9.137 2.436-2.546 5.429-3.819 8.972-3.819s6.591 1.273 9.143 3.819c2.546 2.558 3.825 5.594 3.825 9.137-.007 3.549-1.285 6.591-3.825 9.137zm140.086 0c-2.441 2.558-5.434 3.831-8.971 3.831-3.551 0-6.598-1.273-9.145-3.831-2.551-2.546-3.824-5.582-3.824-9.137 0-3.543 1.273-6.585 3.824-9.137 2.547-2.546 5.594-3.819 9.145-3.819 3.543 0 6.529 1.273 8.971 3.819 2.438 2.558 3.654 5.594 3.654 9.137 0 3.549-1.217 6.591-3.654 9.137zM123.971 406.804c0 10.202 3.543 18.838 10.63 25.925 7.093 7.087 15.729 10.63 25.924 10.63h24.596l.337 75.454c0 9.528 3.323 17.619 9.969 24.266s14.627 9.97 23.929 9.97c9.523 0 17.613-3.323 24.26-9.97s9.97-14.737 9.97-24.266v-75.447h45.864v75.447c0 9.528 3.322 17.619 9.969 24.266s14.73 9.97 24.26 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.737 9.969-24.266v-75.447h24.928c9.969 0 18.494-3.544 25.594-10.631 7.086-7.087 10.631-15.723 10.631-25.924V185.45h-305.09v221.354zM476.275 179.141c-9.309 0-17.283 3.274-23.93 9.804-6.646 6.542-9.969 14.578-9.969 24.094v142.914c0 9.541 3.322 17.619 9.969 24.266s14.627 9.97 23.93 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.725 9.969-24.266V213.039c0-9.517-3.322-17.552-9.969-24.094-6.647-6.53-14.737-9.804-24.26-9.804z"></path>
              </svg>
            ) : (
              <svg
                key={row.id}
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 mr-3"
                x="0"
                y="0"
                enableBackground="new 0 0 512 512"
                version="1.1"
                viewBox="0 0 512 512"
                xmlSpace="preserve"
              >
                <path d="M185.255 512c-76.201-.439-139.233-155.991-139.233-235.21 0-129.404 97.075-157.734 134.487-157.734 16.86 0 34.863 6.621 50.742 12.48 11.104 4.087 22.588 8.306 28.975 8.306 3.823 0 12.832-3.589 20.786-6.738 16.963-6.753 38.071-15.146 62.651-15.146h.146c18.354 0 74.004 4.028 107.461 54.272l7.837 11.777-11.279 8.511c-16.113 12.158-45.513 34.336-45.513 78.267 0 52.031 33.296 72.041 49.292 81.665 7.061 4.248 14.37 8.628 14.37 18.208 0 6.255-49.922 140.566-122.417 140.566-17.739 0-30.278-5.332-41.338-10.034-11.191-4.761-20.845-8.862-36.797-8.862-8.086 0-18.311 3.823-29.136 7.881C221.496 505.73 204.752 512 185.753 512h-.498zM351.343 0c1.888 68.076-46.797 115.304-95.425 112.342C247.905 58.015 304.54 0 351.343 0z"></path>
              </svg>
            )}
          </>
        );
      }
    },
    {
      name: 'FCM Token',
      cell: function render(row) {
        return <span className="text-gray-400">{row.fcm_token}</span>;
      }
    },
    {
      name: 'Created At',
      sortable: true,
      selector: 'created_at',
      cell: function render(row) {
        return (
          <span className="text-gray-400">
            {moment(row.created_at).format('DD MMMM YYYY')}
          </span>
        );
      }
    },

    {
      name: 'Actions',
      cell: function render(row) {
        return (
          <div className="w-full">
            <button
              className="p-1 text-center bg-gray-100 border rounded-lg leading-5 transition-colors duration-150 active:bg-purple-600 hover:bg-gray-300 focus:outline-none focus:shadow-outline-gray"
              onClick={handleDelete(row)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </button>
          </div>
        );
      }
    }
  ];

  const [campaignTargets, setCampaignTargets] = useState([]);
  const [pagination, setPagination] = useState({
    page: PAGINATION.DEFAULT_PAGE,
    perPage: PAGINATION.DEFAULT_PER_PAGE,
    totalData: PAGINATION.DEFAULT_TOTAL_DATA
  });
  const [sortProp, setSortProp] = useState({
    order: 'created_at',
    sort: 'desc'
  });
  const [notification, setNotification] = useState({
    show: false,
    error: false,
    title: '',
    message: ''
  });
  const [showDelete, setShowDelete] = useState(false);
  const [form, setForm] = useState({
    id: null,
    campaign_id: parseInt(query.get('id')),
    name: '',
    email: '',
    device_type: DEVICE_TYPE[0],
    fcm_token: ''
  });
  const [createEdit, setCreateEdit] = useState(false);
  const [target, setTarget] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedTarget, setSelectedTarget] = useState([]);
  const [showSync] = useState(query.get('sync') === '1' || false);

  async function getCampaignTargetList() {
    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;

      const request = {
        limit: pagination.perPage,
        offset: pagination.page,
        keyword: '',
        campaign_id: parseInt(query.get('id')),
        order: sortProp.order,
        sort: sortProp.sort
      };

      const res = await getCampaignTarget(baseUrl, request);

      if (res?.status === STATUS_SUCCESS) {
        setCampaignTargets(res.data);
        setPagination({
          ...pagination,
          totalData: res?.total_data
        });

        return;
      }

      if (res?.status === STATUS_UNAUTHORIZED) {
        localStorage.clear();
        navigate('/login', { replace: true });
        return;
      }

      const err = JSON.parse(await res.text());
      if (err) {
        notif('Error', err.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (error) {
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  async function fetchCustomerFcmList(value) {
    const body = {
      limit: 3,
      offset: 1,
      keyword: value || search,
      order: sortProp.order,
      sort: sortProp.sort
    };

    const baseUrl = process.env.REACT_APP_BASE_URL;

    try {
      const res = await getFcmList(baseUrl, body);

      if (res?.status === STATUS_SUCCESS) {
        setTarget(res.data);

        return;
      }

      if (res?.status === STATUS_UNAUTHORIZED) {
        localStorage.clear();
        navigate('/login', { replace: true });
        return;
      }

      const err = JSON.parse(await res.text());
      if (err) {
        notif('Error', err.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (error) {
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  useEffect(() => {
    getCampaignTargetList();
    fetchCustomerFcmList('');
  }, []);

  let notifTimeout;

  function notif(title, message, error) {
    setNotification({
      ...notification,
      title,
      message,
      error,
      show: true
    });

    if (notifTimeout) clearTimeout(notifTimeout);
    notifTimeout = setTimeout(() => {
      setNotification({ ...notification, show: false });
    }, 3000);
  }

  function closeNotification() {
    setNotification({
      ...notification,
      show: false
    });
  }

  function closeDelete() {
    setShowDelete(false);
  }

  const handleSort = useCallback((column, sortDirection) => {
    setSortProp({
      sort: sortDirection,
      order: column.selector
    });
  });

  function handlePerRowsChange(newPerPage, page) {
    setPagination({
      ...pagination,
      page,
      perPage: newPerPage,
      totalPage: Math.ceil(campaignTargets / newPerPage)
    });
  }

  function handlePageChange(page) {
    setPagination({
      ...pagination,
      page
    });
  }

  const handleDelete = (row) => () => {
    setForm({
      ...form,
      id: row.id
    });

    setShowDelete(true);
  };

  function handleCreateEdit() {
    setCreateEdit(true);
  }

  function handleChangeForm(ev) {
    setForm({
      ...form,
      [ev.target.name]: ev.target.value
    });
  }

  let searchTimeout;

  function handleSearch(value) {
    setSearch(value);
    if (searchTimeout) clearTimeout(searchTimeout);
    searchTimeout = setTimeout(function () {
      fetchCustomerFcmList(value);
    }, 1000);
  }

  function handleDeviceTypeChange(value) {
    setForm({
      ...form,
      device_type: value
    });
  }

  function closeCreateEdit() {
    setCreateEdit(false);
  }

  function handleChangeSelectedTarget(value) {
    const currTarget = selectedTarget.slice(0);
    let isExist = false;

    currTarget.forEach(function (el) {
      if (el.id === value.id) {
        isExist = true;
      }
    });

    if (!isExist) currTarget.push(value);

    setSelectedTarget(currTarget);
  }

  // avoid too much click, use debounce
  let sortTimeout;

  useEffect(() => {
    if (sortTimeout) clearTimeout(sortTimeout);

    sortTimeout = setTimeout(() => {
      getCampaignTargetList();
    }, 500);
  }, [sortProp]);

  function isValid() {
    return (
      form.name?.length > 0 &&
      form.email?.length > 0 &&
      form.fcm_token?.length > 0 &&
      form.device_type?.length > 0
    );
  }

  async function handleCreateCampaignTarget() {
    if (!isValid()) {
      notif('Error', 'Please fill all required field', true);
      return;
    }

    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;

      const res = await createCampaignTarget(baseUrl, form);

      if (res?.status === STATUS_SUCCESS) {
        notif('Success', 'Campaign target successfully created!');
        getCampaignTargetList();

        closeCreateEdit();

        return;
      }

      if (res?.status === STATUS_UNAUTHORIZED) {
        localStorage.clear();
        navigate('/login', { replace: true });
        return;
      }

      const err = JSON.parse(await res.text());
      if (err) {
        notif('Error', err.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (err) {
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  async function handleSubmitCampaignTarget() {
    if (selectedTarget?.length == 0) {
      notif('Error', 'Please choose some users first!', true);
      return;
    }

    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;

      const res = await Promise.all(
        selectedTarget.map(async function (el) {
          const body = el;
          body.campaign_id = parseInt(query.get('id'));
          delete body.id;
          delete body.created_at;
          const response = await createCampaignTarget(baseUrl, body);
          return response;
        })
      );

      if (res?.length === selectedTarget?.length) {
        if (res[0]?.status === STATUS_SUCCESS) {
          notif('Success', 'Campaign target successfully submitted');
          getCampaignTargetList();
          closeCreateEdit();
          return;
        }
        if (res[0].status === STATUS_UNAUTHORIZED) {
          localStorage.clear();
          navigate('/login', { replace: true });
          return;
        }
      }
      const err = JSON.parse(await res[0].text());
      if (err) {
        notif('Error', err.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (err) {
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  async function handleDeleteCampaignTarget() {
    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;

      const res = await deleteCampaignTarget(baseUrl, form);

      if (res?.status === STATUS_SUCCESS) {
        notif('Success', 'Campaign target successfully deleted!');

        getCampaignTargetList();

        closeDelete();
        return;
      }

      if (res?.status === STATUS_UNAUTHORIZED) {
        localStorage.clear();
        navigate('/login', { replace: true });
        return;
      }

      const err = JSON.parse(await res.text());
      if (err) {
        notif('Error', err.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (err) {
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  async function handleSyncCampaignTarget() {
    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const body = { id: form.campaign_id };
      const res = await syncCampaignTarget(baseUrl, body);

      if (res?.status === STATUS_SUCCESS) {
        notif('Success', 'Campaign target successfully synced');
        getCampaignTargetList();
        return;
      }

      if (res?.status === STATUS_UNAUTHORIZED) {
        localStorage.clear();
        navigate('/login', { replace: true });
        return;
      }

      const error = JSON.parse(await res.text());
      if (error) {
        notif('Error', error.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (e) {
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  useEffect(() => {
    if (!createEdit && !showDelete) {
      setForm({
        id: null,
        campaign_id: parseInt(query.get('id')),
        name: '',
        email: '',
        device_type: DEVICE_TYPE[0],
        fcm_token: ''
      });
      setSearch('');
      setSelectedTarget([]);
    }
  }, [createEdit, showDelete]);

  useEffect(() => {
    getCampaignTargetList();
  }, [pagination.page, pagination.perPage]);

  return (
    <div>
      <div className="flex flex-row items-center justify-between pt-5">
        <h2 className="my-6 text-xl font-semibold text-gray-700 dark:text-gray-200">
          Campaign Target - {query.get('name')} - Source: {query.get('source')}
        </h2>
        <div className="flex flex-row">
          {showSync ? (
            <button
              className="px-4 py-2 mr-3 text-sm font-medium text-center bg-white border border-yellow-500 rounded-lg text-secondary leading-5 text-purple transition-colors duration-150 active:bg-yellow-600 hover:bg-yellow-100 focus:outline-none focus:shadow-outline-purple"
              onClick={handleSyncCampaignTarget}
            >
              Sync Campaign Target
            </button>
          ) : null}
          <button
            className="px-4 py-2 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-secondary hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
            onClick={handleCreateEdit}
          >
            Add New
          </button>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={campaignTargets}
        sortServer
        onSort={handleSort}
        pagination
        paginationServer
        paginationTotalRows={pagination.totalData}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
      />

      {/* Create Edit Section */}
      <Transition
        show={createEdit}
        enter="transition-all ease-in duration-100"
        enterFrom="opacity-0"
        enterTo="opacity-100"
      >
        <div className="fixed inset-0 z-20 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0">
              <div className="absolute inset-0 bg-gray-100 opacity-75"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div
              className="relative inline-block px-8 pt-5 pb-8 text-left align-bottom bg-white rounded-lg shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <h3 className="mb-3 font-bold">Create Campaign Target</h3>
              <h3 className="mb-2 text-sm font-semibold text-gray-600">
                Manual Input
              </h3>
              <div
                className="absolute cursor-pointer top-3 right-3"
                onClick={closeCreateEdit}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>

              <label className="block text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Name <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="John Doe"
                  name="name"
                  value={form.name}
                  onChange={handleChangeForm}
                />
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Email <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="john@doe.com"
                  name="email"
                  value={form.email}
                  onChange={handleChangeForm}
                />
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Device Type <span className="text-red-500">*</span>
                </span>
                <Listbox
                  value={form.device_type}
                  onChange={handleDeviceTypeChange}
                >
                  <div className="relative mt-1">
                    <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left bg-white border rounded-lg cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm">
                      <span className="block truncate">{form.device_type}</span>
                      <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-5 h-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                          />
                        </svg>
                      </span>
                    </Listbox.Button>
                    <Transition
                      as={Fragment}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white shadow-lg rounded-md max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        {DEVICE_TYPE.map((device, index) => (
                          <Listbox.Option
                            key={index}
                            className={({ active }) =>
                              `${
                                active
                                  ? 'text-amber-900 bg-amber-100'
                                  : 'text-gray-900'
                              }
                          cursor-default select-none relative py-2 pl-10 pr-4`
                            }
                            value={device}
                          >
                            {({ selected, active }) => (
                              <>
                                <span
                                  className={`${
                                    selected ? 'font-medium' : 'font-normal'
                                  } block truncate`}
                                >
                                  {device}
                                </span>
                                {selected ? (
                                  <span
                                    className={`${
                                      active
                                        ? 'text-amber-600'
                                        : 'text-amber-600'
                                    }
                                absolute inset-y-0 left-0 flex items-center pl-3`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="w-5 h-5"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                      />
                                    </svg>
                                  </span>
                                ) : null}
                              </>
                            )}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </Transition>
                  </div>
                </Listbox>
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  FCM Token <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  name="fcm_token"
                  value={form.fcm_token}
                  onChange={handleChangeForm}
                />
              </label>
              <div className="flex flex-row-reverse">
                <button
                  className="px-4 py-2 mt-3 text-sm font-medium text-center text-white border border-transparent rounded-lg bg-secondary leading-5 transition-colors duration-150 active:bg-purple-600 hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
                  onClick={handleCreateCampaignTarget}
                >
                  {form.id ? 'Edit' : 'Create'}
                </button>
              </div>
              <h3 className="mt-5 mb-2 text-sm font-semibold text-gray-600">
                Input from Master Data
              </h3>
              {selectedTarget?.length ? (
                <div className="flex flex-row flex-wrap mb-3">
                  {selectedTarget.map((el) => {
                    return (
                      <div
                        key={el.id}
                        className="px-3 mr-3 text-sm text-white rounded bg-secondary"
                      >
                        {el.name}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="flex flex-row items-center justify-center p-4 mb-3 text-yellow-600 bg-yellow-200 border border-yellow-600 rounded">
                  Choose some users!
                </div>
              )}
              <Autocomplete
                arrData={target}
                initialValue={search}
                currentSegment={null}
                searchServer={true}
                hintText="Search user"
                onTextChange={handleSearch}
                onChange={handleChangeSelectedTarget}
              />
              <div className="flex flex-row-reverse">
                <button
                  className="px-4 py-2 mt-3 text-sm font-medium text-center text-white border border-transparent rounded-lg bg-secondary leading-5 transition-colors duration-150 active:bg-purple-600 hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
                  onClick={handleSubmitCampaignTarget}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </Transition>

      {/* Delete Section */}
      <Transition
        show={showDelete}
        enter="transition-all ease-in duration-100"
        enterFrom="opacity-0"
        enterTo="opacity-100"
      >
        <div className="fixed inset-0 z-20 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0">
              <div className="absolute inset-0 bg-gray-100 opacity-75"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div
              className="inline-block p-8 overflow-hidden text-left align-bottom bg-white rounded-lg shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <h3 className="font-bold">Delete Confirmation</h3>
              <div
                className="absolute cursor-pointer top-3 right-3"
                onClick={closeDelete}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>

              <p>Are you sure to delete this item?</p>
              <div className="flex flex-row-reverse">
                <button
                  className="px-4 py-2 mt-3 text-sm font-medium text-center text-white border border-transparent rounded-lg bg-secondary leading-5 transition-colors duration-150 hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
                  onClick={closeDelete}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 mt-3 text-sm font-medium text-center border border-transparent rounded-lg leading-5 transition-colors duration-150 focus:outline-none focus:shadow-outline-purple"
                  onClick={handleDeleteCampaignTarget}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </Transition>

      <Notification
        notification={notification}
        closeNotification={closeNotification}
      />
    </div>
  );
}
